import type { ReferencedTweetSummaryAuthor } from './referencedTweetSummaryAuthor';
import type { ReferencedTweetSummaryBasicInfo } from './referencedTweetSummaryBasicInfo';
import type { ReferencedTweetSummaryEngagement } from './referencedTweetSummaryEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export interface ReferencedTweetSummary {
  /** 트윗 작성자 정보 */
  author?: ReferencedTweetSummaryAuthor;
  basicInfo?: ReferencedTweetSummaryBasicInfo;
  engagement?: ReferencedTweetSummaryEngagement;
}
